import Page from './Page.vue'

export default {
    routers() {
        return [
            {
                path: '/page/:type',
                name: 'showPage',
                component: Page,
                props: true
            },
        ];
    }
}



// WEBPACK FOOTER //
// ./src/components/cms/src/Router.js